import { Navigate, useLocation } from "react-router-dom";
import { signInPathFor } from "@/lib/authRedirect";

/**
 * Send a signed-out visitor to sign-in, remembering the page they asked for
 * (BEN-141 FP-150). Clerk's `<RedirectToSignIn />` put its `redirect_url` in a
 * hash, which the login page never reads (it reads `?return_to=`), so a bookmark,
 * an emailed link or a reopened tab landed on /dashboard after signing in. This
 * goes through the same `loginPathFor` and open-redirect guard as the
 * session-expiry path.
 */
export function SignInRedirect() {
  const location = useLocation();
  return <Navigate to={signInPathFor(location)} replace />;
}
